import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {
  ButtonBox,
  StyledDialog,
  DialogBox,
  DialogText,
  DialogTitle,
  StyledCloseIcon,
  BackButton,
} from './styles'
import {
  StudyGuide,
  StudyGuideAssets,
  StudyGuideStudyDays,
} from '../../redux/studyGuides'
import {LinkBox, SecondaryLinkButton} from '../../styles/global'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'

type Props = {
  open: boolean
  setOpen: (value: boolean) => void
  studyDay: number
  studyGuide: StudyGuide
}

const View = ({open, setOpen, studyDay, studyGuide}: Props) => {
  const handleClose = () => {
    setOpen(false)
  }

  const nextDayAssets = studyGuide?.assets?.find(
    a => a.studyDay === (studyDay ?? 0) + 1,
  )

  const getUnifiedAssets = (assets?: StudyGuideStudyDays) => {
    return assets
      ? [
          ...(Array.isArray(assets.video) ? assets.video : []),
          ...(Array.isArray(assets.quiz) ? assets.quiz : []),
          ...(Array.isArray(assets.flashcard_deck)
            ? assets.flashcard_deck
            : []),
          ...(Array.isArray(assets.lecture_slides)
            ? assets.lecture_slides
            : []),
          ...(Array.isArray(assets.practice_exam) ? assets.practice_exam : []),
          ...(Array.isArray(assets.break) ? assets.break : []),
        ]
      : []
  }

  const getNextAssetUrl = (asset?: StudyGuideAssets) => {
    let type = ''

    if (asset) {
      switch (asset.assetType) {
        case 'video':
          type = 'videos'
          break
        case 'quiz':
          type = 'quizzes'
          break
        case 'flashcard_deck':
          type = 'flashcards'
          break
        case 'lecture_slides':
          type = 'slides'
          break
        case 'break':
          type = 'breaks'
          break
        case 'practice_exam':
          type = 'practice-exams'
          break
      }

      return type === 'slides'
        ? asset.downloadUrl ?? ''
        : `/study-guide/${studyGuide?.id}/${asset?.studyDay}/${type}/${asset?.id}`
    }

    return ''
  }

  const nextDayUnifiedAssets = getUnifiedAssets(nextDayAssets)

  return (
    <StyledDialog maxWidth={'md'} onClose={handleClose} open={open}>
      <DialogBox>
        <DialogTitle>
          {nextDayUnifiedAssets.length > 0 ? (
            <>Great Work! You’ve Completed Day {studyDay} of Your Study Plan!</>
          ) : (
            <>Great Work! You’ve Completed the last day of Your Study Plan!</>
          )}
          <StyledCloseIcon
            onClick={handleClose}
            className="x-button"
            style={{
              height: 32,
              width: 32,
              cursor: 'pointer',
            }}
          />
        </DialogTitle>
        <DialogText>
          {nextDayUnifiedAssets.length > 0 ? (
            <>
              You’re making fantastic progress! Ready to move to the next day or
              revisit the course overview?
            </>
          ) : (
            <>
              You're making fantastic progress! Now, get ready for your
              exam—good luck, you've got this!
            </>
          )}
        </DialogText>
        <ButtonBox>
          {nextDayUnifiedAssets.length > 0 && (
            <SecondaryLinkButton
              component={RouterLink}
              to={getNextAssetUrl(nextDayUnifiedAssets[0])}
              onClick={() => setOpen(false)}
            >
              Continue to Day {studyDay + 1}
            </SecondaryLinkButton>
          )}
          <LinkBox
            component={RouterLink}
            to={`/study-guide/${studyGuide?.id}/#day-${studyDay ?? 0}`}
          >
            <BackButton>
              <KeyboardBackspaceIcon />
              Back to {studyGuide.abbreviation} Course
            </BackButton>
          </LinkBox>
        </ButtonBox>
      </DialogBox>
    </StyledDialog>
  )
}

export default View
